var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M4 0C1.7938 0 0 1.7938 0 4v24c0 2.2062 1.7938 4 4 4h16c2.2062 0 4-1.7938 4-4V10h-8c-1.1063 0-2-.8938-2-2V0zm12 0v8h8zm-2.5 25.5c0 .8313-.6687 1.5-1.5 1.5s-1.5-.6687-1.5-1.5v-6.3813l-1.9375 1.9375c-.5875.5875-1.5375.5875-2.1188 0s-.5874-1.5374 0-2.1187l4.5001-4.5c.5875-.5875 1.5374-.5875 2.1187 0l4.5 4.5c.5875.5875.5875 1.5375 0 2.1187-.5875.5813-1.5375.5875-2.1187 0l-1.9375-1.9375V25.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload-file.4b127a41c4b08895ec24af57345a057a.svg";